import { FC } from "react";
import DatePicker from "react-datepicker";
import DatePickerCustomHeaderOneMonth from "../../DatePickerCustomHeaderOneMonth";
import DatePickerCustomHeaderTwoMonth from "../../DatePickerCustomHeaderTwoMonth";

interface DatesViewProps {
  startDate: Date | null;
  endDate: Date | null;
  onChangeDate: (dates: [Date | null, Date | null]) => void;
  monthsToShow: number;
  calendarViewDate: Date | null;
  isDateSelectable: (date: Date) => boolean;
  renderDayContents:  (day: number, date?: Date) => React.ReactNode;
  handleMonthChange: (date:  Date) => void;
}

const DatesView: FC<DatesViewProps> = ({
  startDate,
  endDate,
  onChangeDate,
  monthsToShow,
  calendarViewDate,
  isDateSelectable,
  renderDayContents,
  handleMonthChange,
}) => (
  <div className="">

    <DatePicker
      selected={startDate}
      onChange={onChangeDate}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      monthsShown={monthsToShow}
      showPopperArrow={false}
      inline
      minDate={new Date()}
      openToDate={calendarViewDate || startDate || new Date()}
      filterDate={isDateSelectable}
      renderCustomHeader={(p) => (
        <>
          <div className="block md:hidden">
            <DatePickerCustomHeaderOneMonth {...p} />
          </div>
          <div className="hidden md:block">
            <DatePickerCustomHeaderTwoMonth {...p} />
          </div>
        </>
      )}
      renderDayContents={renderDayContents}
      onMonthChange={handleMonthChange}
    />
  </div>
);

export default DatesView;